export const BorderStyleClasses = {
  BORDER_NONE: ['wf-border-none'],
  BORDER_SOLID: ['wf-border-solid'],
  BORDER_DASHED: ['wf-border-dashed'],
  BORDER_DOTTED: ['wf-border-dotted'],
  BORDER_DOUBLE: ['wf-border-double'],
}

export const BorderSideTopWidthClasses = {
  BORDER_TOP_0: ['wf-border-t-0'],
  BORDER_TOP_THIN: ['wf-border-t'],
  BORDER_TOP_NORMAL: ['wf-border-t-2'],
  BORDER_TOP_BOLD: ['wf-border-t-4'],
  BORDER_TOP_BOLDER: ['wf-border-t-8'],
}

export const BorderSideBottomWidthClasses = {
  BORDER_BOTTOM_0: ['wf-border-b-0'],
  BORDER_BOTTOM_THIN: ['wf-border-b'],
  BORDER_BOTTOM_NORMAL: ['wf-border-b-2'],
  BORDER_BOTTOM_BOLD: ['wf-border-b-4'],
  BORDER_BOTTOM_BOLDER: ['wf-border-b-8'],
}
export const BorderSideLeftWidthClasses = {
  BORDER_LEFT_0: ['wf-border-l-0'],
  BORDER_LEFT_THIN: ['wf-border-l'],
  BORDER_LEFT_NORMAL: ['wf-border-l-2'],
  BORDER_LEFT_BOLD: ['wf-border-l-4'],
  BORDER_LEFT_BOLDER: ['wf-border-l-8'],
}

export const BorderSideRightWidthClasses = {
  BORDER_RIGHT_0: ['wf-border-r-0'],
  BORDER_RIGHT_THIN: ['wf-border-r'],
  BORDER_RIGHT_NORMAL: ['wf-border-r-2'],
  BORDER_RIGHT_BOLD: ['wf-border-r-4'],
  BORDER_RIGHT_BOLDER: ['wf-border-r-8'],
}